<template>
  <div class="columns is-vcentered is-marginless">
    <div class="is-narrow column is-cursor-pointer" @click="dossier.open = !dossier.open">
      <b-icon type="is-colorLogistique"
              :icon="dossier.open ? 'chevron-down-circle-outline' : 'chevron-right-circle-outline'">
      </b-icon>
    </div>
    <div class="is-narrow column is-paddingless">
      <div class="tab is-marginless">
        <ul><li class="is-active-logistique is-marginless mgt-4px has-text-weight-bold"
                @click="dossier.open = !dossier.open">
          {{ dossier.libelle }}
        </li></ul>
      </div>
    </div>
    <div class="is-narrow column is-cursor-pointer pdb-6px" @click="popUpEditFolder = true"
         :class="dossier.open ? '' : 'border-bottom-1px'">
      <b-icon icon="pencil-box-outline" type="is-success">
      </b-icon>
    </div>
    <div class="is-narrow column is-cursor-pointer pdb-6px"
         :class="dossier.open ? '' : 'border-bottom-1px'"
         @click="popUpPreventionDelete = true">
      <b-icon type="is-danger" icon="delete-forever"
      ></b-icon>
    </div>
    <div class="is-narrow column has-text-weight-bold "
         :class="dossier.open ? '' : 'border-bottom-1px'">
        <span class="is-size-7 has-text-default">
         {{ $t('editionProjet.ligneDossier.nbrOt', {nbrOt: dossier.ots.length }) }}
        </span>
    </div>
    <div class="full-width column is-paddingless" :class="dossier.open ? '' : 'border-bottom-1px'">
      <div class="columns is-paddingless is-marginless is-justify-content-end is-vcentered">
        <div class="column is-narrow">
          <qd-progress :value="getPercent()" type="is-colorLogistique" class="width-100">
          </qd-progress>
        </div>
        <div class="column is-narrow width-60px">
          {{ $t('editionProjet.ligneDossier.slider', { done: getNumberTaskDone(),
          total: getNumberTask()}) }}
        </div>
      </div>
    </div>
    <b-modal v-model="popUpEditFolder" has-modal-card class="modal">
      <pop-up-add-folder @refresh="$emit('refresh')" :projetId="$route.params.id"
                         :dossierActuel="dossier">
      </pop-up-add-folder>
    </b-modal>
    <b-modal v-model="popUpPreventionDelete" has-modal-card class="modal">
      <pop-up-prevention @yes="deleteDossierOfProjet()"
                         @no="popUpPreventionDelete = false"
                         :messHeader="this.$t('editionProjet.ligneDossier.deleteDossier')"
                         :cancel="this.$t('general.non')"
                         :validate="this.$t('general.oui')">
      </pop-up-prevention>
    </b-modal>
  </div>
</template>

<script>
import popUpAddFolder from '@/components/logistique/projets/p_addFolder';
import PopUpPrevention from '@/components/general/popUpPrevention';
import { deleteDossier } from '@/api/logistique/dossierLogistiqueTechnique';
import validationGeneral from '@/services/validation/validation';
import messageErreur from '@/services/general/messageErreur';

export default {
  name: 'ligneDossier',
  props: {
    dossier: {
      required: true,
      type: Object,
    },
  },
  components: {
    PopUpPrevention,
    popUpAddFolder,
  },
  data() {
    return {
      popUpEditFolder: false,
      popUpPreventionDelete: false,
    };
  },
  methods: {
    async deleteDossierOfProjet() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await deleteDossier(this.dossier.id);
        loadingComponent.close();
        this.$emit('refresh');
      } catch (e) {
        loadingComponent.close();
        if (e.response.data.error) {
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, null);
          this.error = true;
          return;
        }
        messageErreur(this.$i18n);
        throw e;
      }
    },
    getNumberTaskDone() {
      let task = 0;
      this.dossier.ots.forEach((ot) => {
        task += ot.taches.filter((tache) => { return tache.realise; }).length;
      });
      return task;
    },
    getNumberTask() {
      let task = 0;
      this.dossier.ots.forEach((ot) => {
        task += ot.taches.length;
      });
      return task;
    },
    getPercent() {
      if (this.dossier.ots.length === 0) return 0;
      return (this.getNumberTaskDone() * 100) / this.getNumberTask();
    },
  },
};
</script>

<style scoped>

</style>
